import styled from '@emotion/styled'

export const Container = styled.div<{inverse?: boolean}>`
  align-items: center;
  background: #3a3a3a;
  color: #ffffff;
  display: flex;
  flex-direction: ${props => props.inverse ? 'row-reverse' : 'row'};
  gap: 1rem;
  justify-content: center;
  padding: 2rem;
  width: 100%;

  @media (max-width: 768px) {
    display: none;
  }
`
